import useMediaQuery from '@cannect/hooks/useMediaQuery'
import { MOBILE_WIDTH, STATE_LIST } from 'utils/constants'
import { formatZipCode } from 'utils/formatters'
import { AddressProps } from '../index'
import * as Style from './styles'

interface FormAddressProps {
  isMobile: boolean
  changeAddress: ({ fieldToChange, newValue }: { fieldToChange: string; newValue: string }) => void
  address: AddressProps
  errors: Record<string, string>
}

function FormAddress({ changeAddress, address, errors }: FormAddressProps) {
  const isMobile = useMediaQuery(MOBILE_WIDTH)
  return (
    <Style.FormContainer isMobile={isMobile}>
      {isMobile ? (
        <>
          <div className="input-groups">
            <div>
              <span>CEP *</span>
              <input
                type="text"
                id="cep"
                required
                value={formatZipCode(address?.cep)}
                onChange={(event) => changeAddress({ fieldToChange: 'cep', newValue: event.target.value })}
                maxLength={9}
              />
              {errors.cep && <Style.ErrorMessage>{errors.cep}</Style.ErrorMessage>}
            </div>
          </div>

          <div className="input-groups">
            <div>
              <span>Endereço *</span>
              <input
                type="text"
                id="street"
                required
                value={address?.street}
                onChange={(event) => changeAddress({ fieldToChange: 'street', newValue: event.target.value })}
              />
              {errors.street && <Style.ErrorMessage>{errors.street}</Style.ErrorMessage>}
            </div>
            <div style={{ width: '30%' }}>
              <span>N° *</span>
              <input
                type="text"
                id="address_number"
                required
                value={address?.address_number}
                onChange={(event) =>
                  changeAddress({
                    fieldToChange: 'address_number',
                    newValue: event.target.value
                  })
                }
              />
              {errors.address_number && <Style.ErrorMessage>{errors.address_number}</Style.ErrorMessage>}
            </div>
          </div>

          <div className="input-groups">
            <div>
              <span>Bairro *</span>
              <input
                type="text"
                id="district"
                required
                value={address?.district}
                onChange={(event) => changeAddress({ fieldToChange: 'district', newValue: event.target.value })}
              />
              {errors.district && <Style.ErrorMessage>{errors.district}</Style.ErrorMessage>}
            </div>
          </div>

          <div className="input-groups">
            <div>
              <span>Cidade *</span>
              <input
                type="text"
                id="city"
                required
                value={address?.city}
                onChange={(event) => changeAddress({ fieldToChange: 'city', newValue: event.target.value })}
              />
              {errors.city && <Style.ErrorMessage>{errors.city}</Style.ErrorMessage>}
            </div>
            <div style={{ width: '30%' }}>
              <span>Estado *</span>
              <select
                required
                value={address?.state}
                onChange={(event) => changeAddress({ fieldToChange: 'state', newValue: event.target.value })}>
                <option value="">Selecione um estado</option>
                {STATE_LIST.map((uf) => (
                  <option key={uf} value={uf}>
                    {uf}
                  </option>
                ))}
              </select>
              {errors.state && <Style.ErrorMessage>{errors.state}</Style.ErrorMessage>}
            </div>
          </div>

          <div className="input-groups">
            <div>
              <span>Complemento</span>
              <input
                type="text"
                id="complement"
                value={address?.complement}
                maxLength={64}
                onChange={(event) => changeAddress({ fieldToChange: 'complement', newValue: event.target.value })}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="input-groups">
            <div>
              <span>CEP *</span>
              <input
                type="text"
                id="cep"
                required
                value={formatZipCode(address?.cep)}
                onChange={(event) => changeAddress({ fieldToChange: 'cep', newValue: event.target.value })}
                maxLength={9}
              />
              {errors.cep && <Style.ErrorMessage>{errors.cep}</Style.ErrorMessage>}
            </div>
            <div>
              <span>Endereço *</span>
              <input
                type="text"
                id="street"
                required
                value={address?.street}
                onChange={(event) => changeAddress({ fieldToChange: 'street', newValue: event.target.value })}
              />
              {errors.street && <Style.ErrorMessage>{errors.street}</Style.ErrorMessage>}
            </div>
            <div>
              <span>N° *</span>
              <input
                type="text"
                id="address_number"
                required
                value={address?.address_number}
                onChange={(event) =>
                  changeAddress({
                    fieldToChange: 'address_number',
                    newValue: event.target.value
                  })
                }
              />
              {errors.address_number && <Style.ErrorMessage>{errors.address_number}</Style.ErrorMessage>}
            </div>
          </div>

          <div className="input-groups">
            <div>
              <span>Bairro *</span>
              <input
                type="text"
                id="district"
                required
                value={address?.district}
                onChange={(event) => changeAddress({ fieldToChange: 'district', newValue: event.target.value })}
              />
              {errors.district && <Style.ErrorMessage>{errors.district}</Style.ErrorMessage>}
            </div>
            <div>
              <span>Complemento</span>
              <input
                type="text"
                id="complement"
                value={address?.complement}
                maxLength={64}
                onChange={(event) => changeAddress({ fieldToChange: 'complement', newValue: event.target.value })}
              />
            </div>
          </div>

          <div className="input-groups">
            <div>
              <span>Cidade *</span>
              <input
                type="text"
                id="city"
                required
                value={address?.city}
                onChange={(event) => changeAddress({ fieldToChange: 'city', newValue: event.target.value })}
              />
              {errors.city && <Style.ErrorMessage>{errors.city}</Style.ErrorMessage>}
            </div>
            <div>
              <span>Estado *</span>
              <select
                required
                value={address?.state}
                onChange={(event) => changeAddress({ fieldToChange: 'state', newValue: event.target.value })}>
                <option value="">Selecione um estado</option>
                {STATE_LIST.map((uf) => (
                  <option key={uf} value={uf}>
                    {uf}
                  </option>
                ))}
              </select>
              {errors.state && <Style.ErrorMessage>{errors.state}</Style.ErrorMessage>}
            </div>
          </div>
        </>
      )}
    </Style.FormContainer>
  )
}

export default FormAddress
